// import WebStorage from '@byted/tiktok-zti-cache';

export const setAllCookie = (
  key: string,
  value: string,
  path: string,
  domain?: string,
  maxAge?: number,
  secure?: boolean
) => {
  if (!key || /^(?:expires|max\-age|path|domain|secure)$/i.test(key)) {
    return false;
  }
  document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}${
    maxAge ? `; max-age=${maxAge}` : ''
  }${domain ? `; domain=${domain}` : ''}${path ? `; path=${path}` : ''}${secure ? '; secure' : ''}`;
  return true;
};

/**
 * 设置当前cookie
 * @param cname 需要设置cookie的name
 * @param cvalue 设置的值
 */
export const setCookie = (cname: string, cvalue: string) => {
  setAllCookie(cname, cvalue, '/', undefined, 5184000);
};

/**
 * 获取cookie里面的值
 * @param cname 当前cookie name
 * @returns string
 */
export const getCookie = (key: string) => {
  const value =
    decodeURIComponent(
      document.cookie.replace(
        new RegExp(
          `(?:(?:^|.*;)\\s*${encodeURIComponent(key).replace(/[-.+*]/g, '\\$&')}\\s*\\=\\s*([^;]*).*$)|^.*$`
        ),
        '$1'
      )
    ) || null;
  return value;
};

/**
 * 获取当前浏览器环境支持情况
 * @returns {
 *   isSupportLocalstorage: boolean,
 *   isSupportIndexdb: boolean,
 *   isSupportWebsql: boolean
 * }
 */
// export const getStorageSupport = () => {
//   return WebStorage.support();
// };

/**
 *  判断electron客户端 或 客户端
 *  @return 'electron' | 'web'
 *  */
export const checkEnv = () => {
  const ua = window?.navigator.userAgent;
  const regex = /TTElectron/;
  if (regex.test(ua)) {
    return 'electron';
  }
  return 'web';
};

export const debug = (message?: any, ...optionalParams: any[]) => {
  let flag = (window as any).__zti_debug__ || process.env.NODE_ENV === 'development';
  if (!flag && localStorage) {
    const item = localStorage.getItem('__zti_debug__');
    flag = Boolean(item);
  }
  if (flag) {
    console.log(message, ...optionalParams);
  }
};

export { version as __version__ } from '../package.json';
